module.exports = __webpack_public_path__ + "static/media/icon_fengfu.33a4e0a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/icon_fengfu.svg
// module id = 131
// module chunks = 0